import React from 'react';
import { Alert, Stack, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function AlertsStrip({ overdueCount, mtPercent, storagePercent, pendingInvites }) {
    const navigate = useNavigate();
    const alerts = [];

    if (overdueCount > 0) {
        alerts.push({
            severity: 'error',
            message: `${overdueCount} project${overdueCount > 1 ? 's are' : ' is'} past the deadline.`,
            actionLabel: 'Review',
            onAction: () => navigate('/dashboard/projects'),
        });
    }
    if (mtPercent >= 80) {
        alerts.push({
            severity: 'warning',
            message: `Machine translation usage is at ${mtPercent.toFixed(0)}% of your plan limit.`,
            actionLabel: 'Upgrade',
            onAction: () => navigate('/dashboard/pricing'),
        });
    }
    if (storagePercent >= 80) {
        alerts.push({
            severity: 'warning',
            message: `Storage usage is at ${storagePercent.toFixed(0)}% of your plan limit.`,
            actionLabel: 'Manage',
            onAction: () => navigate('/dashboard/files'),
        });
    }
    if (pendingInvites > 0) {
        alerts.push({
            severity: 'info',
            message: `You have ${pendingInvites} pending team invitation${pendingInvites > 1 ? 's' : ''}.`,
            actionLabel: 'View',
            onAction: () => navigate('/dashboard/team'),
        });
    }

    if (alerts.length === 0) return null;

    return (
        <Stack spacing={1.5} sx={{ mb: 3 }}>
            {alerts.map((a, idx) => (
                <Alert
                    key={idx}
                    severity={a.severity}
                    action={
                        <Button color="inherit" size="small" onClick={a.onAction}>
                            {a.actionLabel}
                        </Button>
                    }
                    sx={{ borderRadius: 2 }}
                >
                    {a.message}
                </Alert>
            ))}
        </Stack>
    );
}
